import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Badge,
    Avatar,
    Menu,
    MenuItem,
    Divider,
    ListItemIcon,
    Tooltip,
    Grid,
    TextField,
    InputAdornment
} from '@material-ui/core';
import {
    Menu as MenuIcon,
    Notifications as NotificationsIcon,
    Person as PersonIcon,
    PersonAdd,
    Settings,
    ExitToApp,
    Visibility,
    VisibilityOff
} from '@material-ui/icons';
import { useStyles } from './Style';
import { handleDrawer } from '../../store/actions/menu';
import { logout } from '../../store/actions/authActions';
import validaSenha from '../../assets/js/validaSenha';
import DialogAlert from './DialogAlert';
import { alterarSenha } from '../../store/actions/funcionario';
import { setarNegocioDoUsuario } from '../../store/actions/negocio';
import { getNotificacoes } from '../../store/actions/notificacoes';

const Header = props => {

    const {
        handleDrawer,
        drawerOpen,
        classes,
        user,
        logout,
        alterarSenha,
        setarNegocioDoUsuario,
        negocioDoUsuario,
        getNotificacoes,
        notificacoes
    } = props

    const negocios = user.funcionarios;
    const { perfis } = user;

    const [anchorProfileMenu, setAnchorProfileMenu] = useState(null);
    const [anchorNotifications, setAnchorNotifications] = useState(null);
    const [toggleAlterarSenhaDialog, setToggleAlterarSenhaDialog] = useState(false);
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errorPassword, setErrorPassword] = useState(false);
    const [msgErrorPassword, setMsgErrorPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [errorNewPassword, setErrorNewPassword] = useState(false);
    const [msgErrorNewPassword, setMsgErrorNewPassword] = useState('');
    const [reNewPassword, setReNewPassword] = useState('');
    const [showReNewPassword, setShowReNewPassword] = useState(false);
    const [errorReNewPassword, setErrorReNewPassword] = useState(false);
    const [msgErrorReNewPassword, setMsgErrorReNewPassword] = useState('');
    const [notifications, setNotifications] = useState(0);
    const openProfileMenu = Boolean(anchorProfileMenu);
    const openNotifications = Boolean(anchorNotifications);

    useEffect(() => {
        let intervalId;

        const startPolling = () => {
            if (!intervalId) {
                intervalId = setInterval(async () => {
                    try {
                        if (negocioDoUsuario > 0) getNotificacoes(negocioDoUsuario);
                    } catch (err) {
                        console.error(err);
                    }
                }, 60000); // 60 segundos
            }
        };

        const stopPolling = () => {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
        };

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                startPolling();
            } else {
                stopPolling();
            }
        };

        // Inicia polling se a aba estiver visível
        if (document.visibilityState === 'visible') {
            startPolling();
        }

        // Escuta mudanças de visibilidade da aba
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            stopPolling();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [negocioDoUsuario]);

    useEffect(() => {
        const { quantidadePerguntasNaoLidas } = notificacoes;
        setNotifications(quantidadePerguntasNaoLidas);
    }, [notificacoes]);

    const handleClickProfileMenu = (event) => {
        setAnchorProfileMenu(event.currentTarget);
    };

    const handleCloseProfileMenu = () => {
        setAnchorProfileMenu(null);
    };

    const handleClickNotifications = (event) => {
        setAnchorNotifications(event.currentTarget);
    };

    const handleCloseNotifications = () => {
        setAnchorNotifications(null);
    };

    const handleVerNotifications = () => {
        setAnchorNotifications(null);
        window.location.href = '/perguntas-e-respostas';
    };

    const handleClickShowNewPassword = () => {
        setShowNewPassword((show) => !show)
    };

    const handleClickShowReNewPassword = () => {
        setShowReNewPassword((show) => !show)
    };

    const handleClickShowPassword = () => {
        setShowPassword((show) => !show)
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const handleReNewPassword = () => {
        let retorno = true;
        if (password.length === 0) {
            setErrorPassword(true);
            setMsgErrorPassword('Informe a senha atual.')
            retorno = false;
        }
        if (!validaSenha(newPassword)) {
            setErrorNewPassword(true);
            setMsgErrorNewPassword('Informe uma senha válida.');
            retorno = false;
        }
        if (newPassword !== reNewPassword) {
            setErrorReNewPassword(true);
            setMsgErrorReNewPassword('Senha diverge da nova senha.');
            retorno = false;
        }
        if (password === newPassword) {
            setErrorNewPassword(true);
            setMsgErrorNewPassword('A nova senha não pode ser igual à senha atual.');
            retorno = false;
        }
        if (retorno) {
            const dados = { id: user.id, senhaAtual: password, senhaNova: newPassword };
            alterarSenha(dados);
            setToggleAlterarSenhaDialog(false);
        }
    }

    function handleChangeNegocio(idNegocio) {
        setarNegocioDoUsuario(idNegocio);
        getNotificacoes(idNegocio);
    }

    return (
        <>
            <AppBar position="absolute" className={clsx(classes.appBar, drawerOpen && classes.appBarShift)} >
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawer}
                        className={clsx(classes.menuButton, drawerOpen && classes.menuButtonHidden)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                        Passarela 44 - Gestão do Negócio
                    </Typography>
                    <Grid className={classes.perfilWrapper} >
                        <TextField
                            variant='outlined'
                            color='primary'
                            size='small'
                            select
                            id="negocio"
                            name="negocio"
                            value={negocioDoUsuario}
                            onChange={e => handleChangeNegocio(e.target.value)}
                            placeholder='Selecione um negócio'
                        >
                            <MenuItem value={0}>Selecione um negócio</MenuItem>
                            {
                                negocios.map((option) => (
                                    <MenuItem key={option.idNegocio} value={option.idNegocio} >
                                        {option.nomeNegocio}
                                    </MenuItem>
                                ))
                            }
                        </TextField>
                        <Tooltip title="Notificações">
                            <IconButton color="inherit"
                                onClick={handleClickNotifications}
                                aria-controls={openNotifications ? 'notification-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={openNotifications ? 'true' : undefined}
                            >
                                <Badge badgeContent={notifications} color="secondary" overlap="rectangular">
                                    <NotificationsIcon />
                                </Badge>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Configurações do Perfil">
                            <IconButton color="inherit"
                                onClick={handleClickProfileMenu}
                                size="small"
                                sx={{ ml: 2 }}
                                aria-controls={openProfileMenu ? 'account-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={openProfileMenu ? 'true' : undefined}
                            >
                                <Avatar sx={{ width: 32, height: 32 }}>{user.nome[0]}</Avatar>
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Toolbar>
            </AppBar>
            <Menu
                anchorEl={anchorProfileMenu}
                id="account-menu"
                open={openProfileMenu}
                onClose={handleCloseProfileMenu}
                onClick={handleCloseProfileMenu}
                slotprops={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                getContentAnchorEl={null}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleCloseProfileMenu}>
                    <ListItemIcon>
                        <PersonIcon fontSize="small" />
                    </ListItemIcon>
                    {user.nome}
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleCloseProfileMenu}>
                    <ListItemIcon>
                        <PersonAdd fontSize="small" />
                    </ListItemIcon>
                    Perfil
                </MenuItem>
                <MenuItem onClick={() => setToggleAlterarSenhaDialog(true)}>
                    <ListItemIcon>
                        <Settings fontSize="small" />
                    </ListItemIcon>
                    Alterar Senha
                </MenuItem>
                <MenuItem onClick={logout}>
                    <ListItemIcon>
                        <ExitToApp fontSize="small" />
                    </ListItemIcon>
                    Sair
                </MenuItem>
            </Menu>

            <Menu
                anchorEl={anchorNotifications}
                id="notification-menu"
                open={openNotifications}
                onClose={handleCloseNotifications}
                onClick={handleCloseNotifications}
                slotprops={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                getContentAnchorEl={null}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={notifications > 0 ? handleVerNotifications : false}>
                    {
                        notifications === 1 ?
                            'Você tem 1 pergunta não lida. Clique para visualizá-la.'
                            : notifications > 1 ?
                                `Você tem ${notifications} perguntas não lidas. Clique para visualizá-las.`
                                : 'Você não tem nenhuma notificação nova.'
                    }
                </MenuItem>
            </Menu>

            <DialogAlert
                openDialog={toggleAlterarSenhaDialog}
                title='Alterar Senha'
                fullWidth={true}
                maxWidth='sm'
                okButton={true}
                okButtonType='submit'
                okButtonClick={handleReNewPassword}
                labelOkButton='Confirmar'
                cancelButton={true}
                labelCancelButton='Cancelar'
                cancelButtonClick={() => setToggleAlterarSenhaDialog(false)}
            >
                <Typography variant="body1" >Informe uma senha com pelo menos 8 caracteres entre letras minúsculas, maiúsculas, números e símbolos.</Typography>
                <Grid item style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                    <TextField
                        variant='outlined'
                        color='secondary'
                        fullWidth
                        id='password'
                        name='password'
                        label='Senha Atual'
                        value={password}
                        onChange={(event) => {
                            setPassword(event.target.value);
                            setErrorPassword(false);
                            setMsgErrorPassword('');
                        }}
                        error={errorPassword}
                        helperText={msgErrorPassword}
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment:
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={
                                            showPassword ? 'hide the password' : 'display the password'
                                        }
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        onMouseUp={handleMouseUpPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                        }} />
                </Grid>
                <Grid item style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                    <TextField
                        variant='outlined'
                        color='secondary'
                        fullWidth
                        id='newPassword'
                        name='newPassword'
                        label='Nova Senha'
                        value={newPassword}
                        onChange={(event) => {
                            setNewPassword(event.target.value);
                            setErrorNewPassword(false);
                            setMsgErrorNewPassword('');
                        }}
                        error={errorNewPassword}
                        helperText={msgErrorNewPassword}
                        type={showNewPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment:
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={
                                            showNewPassword ? 'hide the password' : 'display the password'
                                        }
                                        onClick={handleClickShowNewPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        onMouseUp={handleMouseUpPassword}
                                        edge="end"
                                    >
                                        {showNewPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                        }} />
                </Grid>
                <Grid item style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                    <TextField
                        variant='outlined'
                        color='secondary'
                        fullWidth
                        id='reNewPassword'
                        name='reNewPassword'
                        label='Reinforme a Nova Senha'
                        value={reNewPassword}
                        onChange={(event) => {
                            setReNewPassword(event.target.value);
                            setErrorReNewPassword(false);
                            setMsgErrorReNewPassword('');
                        }}
                        error={errorReNewPassword}
                        helperText={msgErrorReNewPassword}
                        type={showReNewPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment:
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={
                                            showReNewPassword ? 'hide the password' : 'display the password'
                                        }
                                        onClick={handleClickShowReNewPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        onMouseUp={handleMouseUpPassword}
                                        edge="end"
                                    >
                                        {showReNewPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                        }} />
                </Grid>
            </DialogAlert>
        </>
    )
}

const mapStateToProps = state => ({
    drawerOpen: state.menu.drawerOpen,
    user: state.auth.user,
    negocioDoUsuario: state.negocio.negocioDoUsuario,
    notificacoes: state.notificacoes.notificacoes
})
const mapDispatchToProps = dispatch => bindActionCreators({
    handleDrawer,
    alterarSenha,
    logout,
    setarNegocioDoUsuario,
    getNotificacoes
}, dispatch)

export default withStyles(useStyles)(connect(mapStateToProps, mapDispatchToProps)(Header))